import React, { ReactNode } from 'react'
import { Button, Classes } from '@blueprintjs/core'
import { PrettyJson, useDarkMode, Box, ThemedDialog } from './'

type Props = {
  title: string
  jsonData?: object
  isDialogOpen: boolean
  onDialogClose: () => void
  height?: string
  children?: ReactNode
}

const JsonDialog = (props: Props) => {
  const { title, jsonData, isDialogOpen, onDialogClose, height, children } =
    props
  const [darkMode] = useDarkMode()
  return (
    <ThemedDialog
      icon="info-sign"
      isOpen={isDialogOpen}
      onClose={onDialogClose}
      title={title}
      style={{ width: 'min-content' }}
    >
      <div
        className={Classes.DIALOG_BODY}
        style={{
          width: '1000px',
          height: height ?? '1000px',
          overflow: 'auto',
        }}
      >
        <Box p="medium" style={{ background: darkMode ? 'black' : 'white' }}>
          {children ? (
            children
          ) : (
            <PrettyJson collapsed={false} src={jsonData} />
          )}
        </Box>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onDialogClose}>Close</Button>
        </div>
      </div>
    </ThemedDialog>
  )
}

export default JsonDialog
